firebird.factory('videoContentStateService', [
    '$timeout',
    '$interval',
    '$window',
    'logService',
    'socketService',
    'helperService',
    'configService',
    'notificationService',
    'brandingService',
    'localizationService',
    'videoGlobalService',
    'executionEnvironmentEnum',
    function (
        $timeout,
        $interval,
        $window,
        logService,
        socketService,
        helperService,
        configService,
        notificationService,
        brandingService,
        localizationService,
        videoGlobalService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoContentStateService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initContentState = initContentState;

            // owner id of the playing screen share video if any
            self.screenshareOwner = null;

            self.cleanUpScreenShareOwner = cleanUpScreenShareOwner;

            self.setScreenDisplay = setScreenDisplay;
            self.setHasScreenAttribute = setHasScreenAttribute;

            self.previewMinimized = false; // for screen share preview (publish)
            self.localScreenShareAppMuteTimer = null;
            self.localScreenShareAppMuteTimeout = 3000; // is this reasonable?
            self.onPreviewResize = onPreviewResize;
            self.onScreenShareMinimized = onScreenShareMinimized;
            self.onLocalScreenShareAppMute = onLocalScreenShareAppMute;
            self.clearLocalScreenShareAppMuteTimer = clearLocalScreenShareAppMuteTimer;
            self.onSfuScreenShareSubStateChanged = onSfuScreenShareSubStateChanged;
            self.onScreenVideoMinimized = onScreenVideoMinimized;
            self.handleUiChangesOnVdi = handleUiChangesOnVdi;

            self.showPicOnAppMin = false;
            self.showPicCanvas = null;
            self.showPicSnapshot = null; // receive side only
            self.showPicInterval = null;
            self.showPicIntervalValue = 5000; // interval to take snapshots.
            self.showPicMaxSize = 320;
            self.createPeriodicAppSnapshotInterval = createPeriodicAppSnapshotInterval;
            self.clearPeriodicAppSnapshotInterval = clearPeriodicAppSnapshotInterval;
            self.getLastAppSnapshot = getLastAppSnapshot;

            self.setCustomImageStyles = setCustomImageStyles;

            $scope.$on('sfu-screenshare-substate-changed', onSfuScreenShareSubStateChanged);

            // screen share state changed
            $scope.$on('content-status', onContentStatus);
            $scope.$on('fs-content-started', onContentStarted);

            self.hasPrimaryScreen = false;
            self.screenVideoCount = 0;
            self.onScreenVideoCount = onScreenVideoCount;
            $scope.$on('screen-video-count', onScreenVideoCount);
        }

        //update from config
        function initContentState() {
            self.showPicOnAppMin = (configService.getValue('showPicOnAppMin') || 'false') === 'true';
        }

        // dynamically create SVG image with localization for app share minimized screen, and update CSS background-image property.
        function setCustomImageStyles() {
            try {
                // inline styles are needed here.
                var image =
                    '<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"\n' +
                    '    width="720" height="360" viewbox="0 0 720 360" preserveAspectRatio="slice"\n' +
                    '    style="height: 720px; width: 360px; background: transparent;">\n' +
                    '    <text x="360" y="140" text-anchor="middle" alignment-baseline="middle" fill="white" style="font-family: noto-sans, sans-serif; font-size: 16px;">' +
                    localizationService.translate('SCREENSHARE.SHARED_APP_MINIMIZED') +
                    '</text>\n' +
                    '    <text x="360" y="180" text-anchor="middle" alignment-baseline="middle" fill="white" style="font-family: noto-sans, sans-serif; font-size: 12px;">' +
                    localizationService.translate('SCREENSHARE.SHARED_APP_MINIMIZED_DESCRIPTION') +
                    '</text>\n' +
                    '    <text x="360" y="210" text-anchor="middle" alignment-baseline="middle" fill="white" style="font-family: noto-sans, sans-serif; font-size: 12px;">' +
                    localizationService.translate('SCREENSHARE.PLEASE_STAND_BY') +
                    '</text>\n' +
                    '</svg>';

                var dataurl = 'data:image/svg+xml;base64,' + helperService.b64EncodeUnicode(image);
                var existing = $window.$('head > style#customImageStyle');
                if (!existing.length) {
                    $window.$('head').append('<style type="text/css" id="customImageStyle"></style>');
                    existing = $window.$('head > style#customImageStyle');
                }
                existing[0].innerText =
                    '#videoroom #videoroom-videos>div.remote.screen[minimized=true][snapshot=true]:before { background-size: cover; filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 1)); background-image: url("' +
                    dataurl +
                    '") !important;}';
            } catch (e) {
                logger.error('setCustomImageStyles', 'failed to add style.customImageStyle element', e);
            }
        }

        // screen share preview is resized. this calls onScreenShareMinimized, with true if 2x2 else false.
        function onPreviewResize() {
            const video = $window.$('#localScreenShareFeed')[0];
            if (video && self.screenstream) {
                self.onScreenShareMinimized(video.videoWidth == 2 && video.videoHeight == 2);
                if (
                    self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                    self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
                ) {
                    const videoElementBounds = video.getBoundingClientRect();
                    if (videoElementBounds) {
                        $window
                            .$('#localSfuScreenShareFeedContainer')
                            .width(videoElementBounds.width)
                            .height(videoElementBounds.height);
                    }
                }
            }
        }

        // when screen share preview video receives a mute or unmute event, call onScreenShareMinized.
        // but delay the call for mute, to handle immediate unmute, which causes flicker. ANYAM-32015. Chrome 81.
        function onLocalScreenShareAppMute(value) {
            self.clearLocalScreenShareAppMuteTimer();

            if (value) {
                self.localScreenShareAppMuteTimer = $timeout(function () {
                    logService.log('videoroomCtrl screen share app mute timer expired');
                    self.localScreenShareAppMuteTimer = null;
                    self.onScreenShareMinimized(true);
                }, self.localScreenShareAppMuteTimeout);
            } else {
                self.onScreenShareMinimized(false);
            }
        }

        function clearLocalScreenShareAppMuteTimer() {
            if (self.localScreenShareAppMuteTimer) {
                $timeout.cancel(self.localScreenShareAppMuteTimer);
                self.localScreenShareAppMuteTimer = null;
            }
        }

        // when app sharing is minimized (value == true) or restored (value == false).
        // If noSend is true, then do not send message.
        function onScreenShareMinimized(value, noSend) {
            logService.log('videoroomCtrl screen share minimized: ' + value);
            var sendUpdate = false;

            if (value && !self.previewMinimized) {
                sendUpdate = true;
                self.previewMinimized = true;
                // delay external notification, in case it was due to some other transient/reconnection reason.
                // after 2s, if preview is still small sized, then display notification.
                $timeout(function () {
                    if (self.previewMinimized) {
                        // use notification, because presenter is likely not viewing this client.
                        notificationService.show(
                            localizationService.translate(
                                'SCREENSHARE.NOTIFICATIONS.YOU_VIEWERS_CAN_NOT_SEE_WHAT_YOU_SHARING'
                            ),
                            'warning',
                            localizationService.translate('SCREENSHARE.NOTIFICATIONS.DID_YOU_MINIMIZE_THE_APPLICATION')
                        );
                    }
                }, 2000);

                var swalOptions;

                var closeButtonHtml =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                swalOptions = {
                    title:
                        closeButtonHtml +
                        localizationService.translate('SCREENSHARE.NOTIFICATIONS.CONTENT_SHARE_INTERRUPTED'),
                    text: localizationService.translate(
                        'SCREENSHARE.NOTIFICATIONS.MINIMIZING_SHARED_APP_PREVENT_SHARING'
                    ),
                    showConfirmButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.CLOSE_TEXT'),
                    allowOutsideClick: true,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg',
                    customClass: 'screen-share-failed-to-start-modal'
                };
                $window.swal(swalOptions);

                $window.$('#localSfuScreenShareFeedContainer').attr('minimized', 'true');
            } else if (!value && self.previewMinimized) {
                sendUpdate = true;
                self.previewMinimized = false;
                $window.$('#localSfuScreenShareFeedContainer').removeAttr('minimized');
                // Hacky way to detect if the same sweet alert is open now, then close it.
                if ($window.$('.sweet-alert.visible > h2').text() == 'Content share is interrupted') {
                    $window.swal.close();
                }
            }

            if (sendUpdate && !noSend) {
                logService.log('videoroomCtrl sending sfu-screenshare-set-substate minimized=' + self.previewMinimized);
                var data = {
                    message: 'sfu-screenshare-set-substate',
                    data: self.previewMinimized ? 'minimized' : null
                };
                if (self.showPicOnAppMin && self.previewMinimized) {
                    data.data = { value: 'minimized', snapshot: self.getLastAppSnapshot() };
                }
                socketService.send(data);
            }
        }

        // received screenshare-muted from publisher
        function onSfuScreenShareSubStateChanged(e, data) {
            if (data && data.ownerID == self.screenshareOwner && data.ownerID != self.attendantId) {
                self.screenshareSubState = data.value;
                var div = $window.$(
                    '#videoroom-videos div.remote.screen[user="' +
                        self.getScreenshareIdFromAttendantId(data.ownerID) +
                        '"]'
                );
                if (div.length > 0) {
                    self.onScreenVideoMinimized(div[0], self.screenshareSubState);
                } else {
                    logService.log('videoroomCtrl on received screen share muted, div not found for ' + data.ownerID);
                }
            } else {
                logService.log(
                    'videoroomCtrl on received sfu-screenshare-substate-change, ignored. Owner=' +
                        data.ownerID +
                        ' currentOwner=' +
                        self.screenshareOwner +
                        ' self=' +
                        self.attendantId
                );
            }
        }

        // when a remote screen video indicates it is minimized. set the attribute so that right CSS/img can be applied.
        function onScreenVideoMinimized(div, data) {
            var value = !!data; // since only one value of minimized is supported currently.
            logService.log('videoroomCtrl onScreenVideoMinimized value=' + value);
            if (!self.VDIRef.showContentsOnTopOfVideo) {
                self.handleUiChangesOnVdi(value);
            }
            var img0 = div.querySelector('img.snapshot');
            if (img0) {
                div.removeChild(img0);
                div.removeAttribute('snapshot');
            }
            if (data && typeof data === 'object' && data.snapshot) {
                // for backward compatibility
                var img1 = document.createElement('img');
                img1.className = 'snapshot';
                img1.src = self.showPicSnapshot = data.snapshot;
                div.appendChild(img1);
                div.setAttribute('snapshot', 'true');
            }
            if (value && !div.hasAttribute('minimized')) {
                div.setAttribute('minimized', 'true');
            } else if (!value && div.hasAttribute('minimized')) {
                div.removeAttribute('minimized');
            }
        }

        function cleanUpScreenShareOwner() {
            if (self.screenshareOwner) {
                self.stopVideoPlay(self.screenshareOwner, true);
                self.screenshareOwner = null;
                self.screenshareSubState = null;
                if (self.screenshareState != 'disconnected' && self.screenshareState != 'stopped') {
                    self.fileplay = false;
                }
                self.setScreenDisplay(false);
            }

            self.talkerActive = null;
        }

        function onContentStatus(e, data) {
            // on node server restart, type and owner are empty, but it must cleanup if needed.
            if (!data.type && !data.ownerID && data.state == 'stopped') {
                if (self.screenshareOwner) {
                    self.cleanUpScreenShareOwner();
                }
                if (self.screenshareState == 'stopped') {
                    self.screenshareState = 'disconnected'; // so that start screen share happens on janus reconnection
                }
                if (self.screenshareState == 'disconnected') {
                    if (self.janus && self.janus.isConnected()) {
                        if (!self.screenshare) {
                            logService.log(
                                'videoroomCtrl restarting screenshare, as it is stopped at server on reconnect, state=' +
                                    self.screenshareState
                            );
                            self.startScreenShare();
                        }
                    } else {
                        logService.log(
                            'videoroomCtrl not restarting screenshare after reconnect as not yet connected to Janus, state=' +
                                self.screenshareState
                        );
                    }
                } else if (self.screenshareState && !self.isScreenVideo) {
                    logService.log(
                        'videoroomCtrl stopping screenshare, as it is stopped at server on reconnect, state=' +
                            self.screenshareState
                    );
                    self.stopScreenShare(true);
                }
            } else {
                if (data.state == 'running') {
                    if (self.attendantId != data.ownerID) {
                        if (self.screenshareState && !self.isScreenVideo) {
                            // during reconnect: someone else started publishing, we need to stop ours.
                            logService.log(
                                'videoroomCtrl stopping screenshare reconnect, as someone else started, new owner=' +
                                    data.ownerID
                            );
                            self.stopScreenShare(true);
                        }
                    } else {
                        if (data.type == 'screenshare') {
                            if (!self.screenshareState) {
                                // server thinks we are sharing, but we are not. stop ours. How?
                                logger.error(
                                    'onContentStatus',
                                    `content status is running for this publisher, but we are not sharing, stopping now, state=${self.screenshareState}`
                                );
                                self.stopScreenShare('cleanup');
                            } else {
                                if (self.screenshareState == 'stopped') {
                                    self.screenshareState = 'disconnected'; // so that start screen share happens on janus reconnection
                                }
                                if (self.screenshareState == 'disconnected') {
                                    self.fileplay = !!data.isFilePlay;
                                    if (self.janus && self.janus.isConnected()) {
                                        if (!self.screenshare) {
                                            logService.log(
                                                'videoroomCtrl restarting screenshare, as server state is still running, state=' +
                                                    self.screenshareState
                                            );
                                            self.startScreenShare();
                                        }
                                    } else {
                                        logService.log(
                                            'videoroomCtrl not restarting screenshare after reconnect as not yet connected to Janus, state=' +
                                                self.screenshareState
                                        );
                                    }
                                }
                            }
                        }
                    }
                } else if (data.state == 'stopped') {
                    if (data.type == 'screenshare' && self.attendantId == data.ownerID && self.screenshareState) {
                        // received stopped for self, stop it even if in reconnecting
                        logService.log(
                            'videoroomCtrl stopping screenshare, as it is stopped, state=' + self.screenshareState
                        );
                        self.stopScreenShare(true);
                    }
                }
            }

            if (data.type == 'screenshare') {
                logService.log('videoroomCtrl on content status screenshare ' + data.state + ' owner=' + data.ownerID);
                if (data.state == 'running') {
                    if (self.attendantId != data.ownerID) {
                        self.screenshareOwner = data.ownerID;
                        self.fileplay = !!data.isFilePlay;
                        self.screenshareSubState = data.subState || null;
                        self.startVideoPlay(self.screenshareOwner, true, true);
                        self.setScreenDisplay(true);
                    }
                } else if (data.state == 'stopped') {
                    if (self.attendantId != data.ownerID) {
                        self.cleanUpScreenShareOwner();
                    }
                }
            }
        }

        function onContentStarted(e, data) {
            if (data.type == 'screenshare' && self.fileplay) {
                logService.log('videoroomCtrl on content recording video file');
                if (self.fileVideo && self.fileVideo.paused) {
                    self.fileVideo.play();
                }
            }
        }

        // set the screen display attribute and variable. This is used by talkerLayout.
        function setScreenDisplay(value) {
            self.hasPrimaryScreen = value;
            self.setHasScreenAttribute();
        }

        function setHasScreenAttribute() {
            var hasScreenVideo = false;
            if (self.multishare) {
                // this should be same as header.html's layout dropdown button to show/hide content videos.
                hasScreenVideo = self.screenVideoCount - (self.isScreenVideo ? 1 : 0) > 0;
            }

            self.hasScreenDisplay = self.hasPrimaryScreen || hasScreenVideo;

            if (self.hasScreenDisplay) {
                $window.$('#videoroom-videos').attr('hasScreen', 'true');
            } else {
                $window.$('#videoroom-videos').removeAttr('hasScreen');

                if (self.isCompactMode) {
                    self.compactAssignTalkerOnUpdateLayout();
                }
            }
        }

        function onScreenVideoCount(e, count) {
            if (self.multishare) {
                self.screenVideoCount = count;
                self.setHasScreenAttribute();
            }
        }

        function clearPeriodicAppSnapshotInterval() {
            if (self.showPicCanvas) {
                self.showPicCanvas = null;
            }
            if (self.showPicInterval) {
                $interval.cancel(self.showPicInterval);
                self.showPicInterval = null;
            }
        }

        function createPeriodicAppSnapshotInterval() {
            self.showPicCanvas = document.createElement('canvas');

            var periodicHandler = function () {
                var video = $window.$('#localSfuScreenShareFeedContainer > video')[0];
                if (
                    self.showPicCanvas &&
                    !self.previewMinimized &&
                    video &&
                    video.videoWidth > 2 &&
                    video.videoHeight > 2
                ) {
                    var width = video.videoWidth,
                        height = video.videoHeight;
                    var ratio = width / height;
                    if (width >= height) {
                        width = self.showPicMaxSize;
                        height = width / ratio;
                    } else {
                        height = self.showPicMaxSize;
                        width = height * ratio;
                    }
                    self.showPicCanvas.width = width;
                    self.showPicCanvas.height = height;
                    self.showPicCanvas.getContext('2d').drawImage(video, 0, 0, width, height);
                }
            };

            //self.showPicInterval = $interval(periodicHandler, self.showPicIntervalValue);
            $timeout(periodicHandler, 2000);
        }

        function getLastAppSnapshot() {
            if (self.showPicCanvas) {
                return self.showPicCanvas.toDataURL();
            }
            return null;
        }

        function handleUiChangesOnVdi(isScreenVideoMinimized) {
            const screenVideoElement = $window.$('.remote.screen.primary > video');
            if (isScreenVideoMinimized) {
                // Hide screenshare stream to show application minimized message.
                screenVideoElement.get(0).style.display = 'none';
                screenVideoElement.addClass('screenshare-stream-interrupted');
            } else {
                if ($window.Janus?.getModalsOpenInVdiCount() === 0) {
                    screenVideoElement.get(0).style.display = 'inline-block';
                }
                screenVideoElement.removeClass('screenshare-stream-interrupted');
            }
        }
    }
]);
